import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const partnerTotalRevenueAction = createAsyncThunk(
    'partner-total-revenue',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/partner-total-revenue?startDate=${data?.startDate}&endDate=${data?.endDate}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const partnerTotalRevenueSlice = createSlice({
    name: 'partner-total-revenue',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(partnerTotalRevenueAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(partnerTotalRevenueAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(partnerTotalRevenueAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const partnerTotalRevenueReducer = partnerTotalRevenueSlice.reducer
